// Pops each stat tile in with a little squishy bounce the first time it
// scrolls into view. Skips entirely for prefers-reduced-motion (tiles are
// simply visible from the start, no animation queued).
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var items = document.querySelectorAll('[data-squishy-stat]');
  if (!items.length || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );

  items.forEach(function (item, index) {
    item.style.setProperty('--stat-delay', index * 90 + 'ms');
    observer.observe(item);
  });
})();
